///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2023 - 2023
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { includes, orderBy } from "lodash";

import { assetType, carrierMatchingEqTypes } from "./types";
import { mapOdLoadingTypes } from "./mapOdLoadingTypes";

export const reverseMapLaneCarrierCapacityMatch = (
  capacityMatches,
  rowsSelected,
  copyMatchesFromRow = null
) => {
  let laneMatches = [];
  let isNoneOptionSelected = false;
  const laneInfo = capacityMatches?.filter(x =>
    includes(rowsSelected, x.truckloadLaneId)
  );
  const copyFromlaneMatches =
    copyMatchesFromRow &&
    capacityMatches?.find(x => copyMatchesFromRow === x.truckloadLaneId)
      .laneMatches;

  laneInfo.map(lane => {
    const matches =
      copyMatchesFromRow === null ? lane.laneMatches : copyFromlaneMatches;
    return matches.map(laneMatch => {
      if (laneMatch.carrierId === null) {
        return (isNoneOptionSelected = true);
      } else {
        return laneMatches.push({
          carrierId: laneMatch.carrierId,
          carrierName: laneMatch.carrierName,
          carrierCode: laneMatch.carrierCode,
          incumbent: laneMatch.incumbent,
          checked: true,
          odLoadingTypes: orderBy(mapOdLoadingTypes(laneMatch.odLoadingTypes), [
            "value"
          ]),
          assetType: assetType.find(x => x.value === laneMatch.assetType),
          equipmentType: carrierMatchingEqTypes.find(
            x => x.value === laneMatch.equipmentType
          ),
          weeklyCap: laneMatch.weeklyCap,
          carrierRate: laneMatch.carrierRate.toString(),
          notes: laneMatch.notes ? laneMatch.notes : "",
          showNotes: laneMatch.notes ? true : false,
          truckloadLaneId: lane.truckloadLaneId
        });
      }
    });
  });

  return { laneMatches, isNoneOptionSelected };
};

export default reverseMapLaneCarrierCapacityMatch;
